export const EMPTY_STATE_KEY = {
  GETTING_STARTED: "gettingStarted",
  NO_TEMPLATE: "noTemplate",
};

export const EMPTY_STATE_TEMPLATE = {
  [EMPTY_STATE_KEY.GETTING_STARTED]: {
    title: "Get started with Optics",
    description:
      "Pick a macro and get started with designing your confluence page!",
    imageUrl: "/img/get-started-with-optics.svg",
  },
  [EMPTY_STATE_KEY.NO_TEMPLATE]: {
    title: "Pick a macro template",
    description: "And get started with designing your confluence page!",
    imageUrl: "/img/get-started-with-optics.svg",
  },
};
